var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useSetAtom } from "jotai";
import { CONFIG } from "./config";
import { extractLocaleFromUbisoftURL, UrlLocale } from "./ubisoft/locale";
import { useCallback } from "react";
var requireLang = require.context("./locs");
export var DEFAULT_LOCALE = CONFIG.textures.defaultLocale;
export var ARTBOOK_LOCALES = CONFIG.textures.locales.map(function (locale) { return locale.name; });
function getMappedLocale(s) {
    var e_1, _a;
    try {
        for (var _b = __values(CONFIG.locales), _c = _b.next(); !_c.done; _c = _b.next()) {
            var e = _c.value;
            if (e.secondaryCodes != null && e.secondaryCodes.indexOf(s) !== -1) {
                return e.code;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
export function localeToLang(s) {
    return s.split("-")[0];
}
export function getDefaultLocale() {
    var ubiLocale = extractLocaleFromUbisoftURL(window.location.href);
    if (ubiLocale != null) {
        return findBestLocale([ubiLocale]);
    }
    else {
        return findBestLocale(navigator.languages);
    }
}
export function findBestLocale(locales) {
    var langToCheck = __spreadArray(__spreadArray([], __read(locales), false), __read(locales.map(extractLanguageFromLocale)), false);
    var bestMatchingLocs = langToCheck
        .map(findBestMatchingLocale)
        .filter(notNull);
    if (bestMatchingLocs.length > 0) {
        return bestMatchingLocs[0];
    }
    return DEFAULT_LOCALE;
}
function extractLanguageFromLocale(locale) {
    return locale.split("-")[0];
}
export function isLocaleAvailable(locale) {
    return requireLang.keys().indexOf("./".concat(locale, ".json")) !== -1;
}
function findBestMatchingLocale(localeOrLanguage) {
    var e_2, _a;
    var mappedLocale = getMappedLocale(localeOrLanguage);
    if (isLocaleAvailable(mappedLocale)) {
        return mappedLocale;
    }
    else {
        try {
            for (var _b = __values(requireLang.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var e = _c.value;
                if (e.startsWith("./" + mappedLocale + "-")) {
                    return e.substring(2, e.length - 5);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return null;
}
export function getLocaleMessages(locale) {
    return requireLang("./".concat(locale, ".json"));
}
export function listAvailableLocales() {
    var files = requireLang.keys();
    return CONFIG.locales
        .map(function (e) { return e.code; })
        .filter(function (locale) {
        return files.some(function (file) { return new RegExp("".concat(locale, ".json")).test(file); });
    });
}
export function useNavigateToLocale() {
    var setLocale = useSetAtom(UrlLocale);
    return useCallback(function (locale) {
        setLocale(locale);
        if (process.env.DEBUG_ROUTER_ENABLED === "true") {
            var qs = new URLSearchParams(window.location.search);
            qs.set("locale", locale);
            window.history.pushState({}, "", "?".concat(qs.toString()).concat(window.location.hash));
            return;
        }
        var newUrl = process.env.WEB_ROOT_URL.replace(":locale", locale);
        window.history.pushState({}, "", newUrl);
    }, [setLocale]);
}
export function getLocaleName(locale) {
    var _a, _b;
    return (_b = (_a = CONFIG.locales.find(function (e) { return e.code === locale; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Unknown lang";
}
function notNull(e) {
    return e != null;
}
